
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/mallview/[code]",
      function () {
        return require("private-next-pages/parts/mallview/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/mallview/[code]"])
      });
    }
  